<template>
  <div>
    <CompactCardReview
      :candidate="candidate"
      :tab="tab"
      :projectId="projectId"
      :isSelected="isSelected ?? false"
      :tabs="tabs"
      :disabledMoveCandidate="disabledMoveCandidate"
      :notInterestedReason="notInterestedReason"
      :showTooltip="showTooltip"
      :isLoading="loading"
      :isHideMenu="isHideMenu"
      @openCandidateCard="$emit('open')"
      @select="candidateSelect"
      @mail="onMailClick"
      @shareExport="onShareExport"
      @move="onMove"
      @not-interested="updateRejectedReason"
      @handleClick="handleClick"
      @activityHistory="onActivityHistory"
      @chat="onChatClick"
      @note="onNoteClick"
    />
  </div>
</template>

<script>
import constants from '@/js/constants';
import CompactCardReview from '@/components/v3/widgets/CompactCardReview';

export default {
  name: 'compact-cardv2',
  components: {
    CompactCardReview,
  },

  props: {
    candidate: Object,
    tab: String,
    isHideMenu: Boolean,
    projectId: String,
    tabs: Array,
    disabledMoveCandidate: Boolean,
    loading: Boolean,
    isSelected: Boolean,
  },

  data() {
    return {
      selected: false,
      showMenu: false,
      notInterestedReason: '',
      // From backend models.NotInterestedCodes
      notInterestedReasons: {
        MISCLASSIFICATION: 'Misclassification',
        TIMING: 'Timing',
        COMPENSATION: 'Compensation',
        SENIORITY: 'Seniority',
        REMOTE_POLICY: 'Remote Work Policy',
        COMPANY_FIT: 'Company Fit',
        VISA: 'Work/Visa Status',
        OTHER: 'Other',
        ROLE_FIT: 'Role Fit',
        MAKING_REFERRAL: 'Referred Colleague',
        WRONG_EMAIL: 'Wrong email',
      },
    };
  },

  computed: {
    showTooltip() {
      if (
        this.rejection_reason_formatted_string().length <= 21 ||
        this.candidate.rejection_reason_other !== ''
      ) {
        return true;
      }
      return false;
    },

    reviewerName() {
      return this.candidate.history && this.candidate.history.length
        ? this.candidate.history[this.candidate.history.length - 1].user_name
        : '';
    },
  },

  watch: {
    isHideMenu() {
      if (this.isHideMenu === true) {
        this.showMenu = false;
      }
    },

    $route(to, from) {
      if (this.$route.query.candidate === this.candidate.id) {
        this.setSelected(true);
        this.$emit('select');
      }
    },
  },

  mounted() {
    if (this.$route.query.candidate === this.candidate.id) {
      this.setSelected(true);
      this.$emit('select');
    }
    const notInterestedReasonsTmp =
      this.candidate &&
      this.candidate.not_interested_reason &&
      this.candidate.not_interested_reason.length &&
      this.candidate.not_interested_reason[0]
        ? this.notInterestedReasons[
            this.candidate.not_interested_reason[0].toUpperCase()
          ]
        : '';
    this.notInterestedReason = notInterestedReasonsTmp;
  },

  methods: {
    updateRejectedReason(e) {
      this.notInterestedReason = e;
    },

    openMenu() {
      this.$emit('is-show-menu');
    },

    handleClick(e) {
      e.stopPropagation();
    },

    candidateSelect() {
      this.$emit('select', this.candidate);
    },

    setSelected(value) {
      this.selected = value;
    },

    getCandidateName(candidate) {
      if (candidate.name) return candidate.name;
      let name = '';
      if (candidate.first_name) name += candidate.first_name;
      if (candidate.last_name) name = `${name} ${candidate.last_name}`;
      return name;
    },

    getCandidateLocation(candidate) {
      if (candidate.location) return candidate.location;
      let location = '';
      if (candidate.city) location += `${candidate.city}, `;
      if (candidate.state) location += candidate.state;
      else location += candidate.country;
      return location;
    },

    openLinkedin() {
      if (
        constants.RECRUITER_PROFILE_USERS.includes(
          localStorage.getItem('email')
        )
      ) {
        window.open(this.candidate.linkedin_recruiter_url, '_blank');
      } else {
        window.open(this.candidate.linkedin_profile_url, '_blank');
      }
    },

    detailed_contacted_status() {
      if (this.tab === 'CONTACTED') {
        if (this.candidate.follow_up_3_date) {
          return `Follow-Up #3 sent: ${this.candidate.follow_up_3_date}`;
        }
        if (this.candidate.follow_up_2_date) {
          return `Follow-Up #2 sent: ${this.candidate.follow_up_2_date}`;
        }
        if (this.candidate.follow_up_1_date) {
          return `Follow-Up #1 sent: ${this.candidate.follow_up_1_date}`;
        }
        return `Initial outreach sent: ${this.candidate.contacted_date}`;
      }
      return '';
    },

    rejection_reason_formatted_string() {
      let final_formatted_string = '';
      if (this.candidate.rejection_reason_formatted) {
        let i;
        for (i = 0; i < this.candidate.rejection_reason_formatted.length; i++) {
          final_formatted_string +=
            this.candidate.rejection_reason_formatted[i];
          if (i === this.candidate.rejection_reason_formatted.length - 1) {
            break;
          } else {
            final_formatted_string += ', ';
          }
        }
      }

      return final_formatted_string;
    },

    most_recent_outreach_date() {
      if (this.candidate.follow_up_3_date) {
        return this.candidate.follow_up_3_date;
      }
      if (this.candidate.follow_up_2_date) {
        return this.candidate.follow_up_2_date;
      }
      if (this.candidate.follow_up_1_date) {
        return this.candidate.follow_up_1_date;
      }
      return this.candidate.contacted_date;
    },

    async updateCandidate() {
      try {
        this.rejectionSubmitLoading = true;
        const project = {};
        await this.$store.dispatch('projects/settings/updateProject', {
          projectId: this.projectId,
          project,
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.rejectionSubmitLoading = false;
      }
    },

    onMailClick() {
      this.selected = true;
      this.$emit('email');
    },

    onActivityHistory() {
      this.selected = true;
      this.$emit('activityHistory');
    },

    onChatClick() {
      this.selected = true;
      this.$emit('chat');
    },

    onNoteClick() {
      this.selected = true;
      this.$emit('note');
    },

    onShareExport(event) {
      this.selected = true;
      this.$emit('shareExport', event);
    },

    onMove(event) {
      this.selected = true;
      this.$emit('move', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
$danger: #b34045;

.card {
  border: 2px solid transparent;
  border-radius: 1.25rem;
  box-shadow: -1px 3px 6px 0 rgba(68, 68, 68, 0.53) !important;

  &::before {
    background-color: white;
  }

  &.outreached {
    border-color: $danger;
  }
  &::v-deep .v-label {
    font-size: 0.875rem;
  }

  .card-text {
    text-align: center;
    margin-bottom: 0.75rem;
    margin-right: 1.5rem;

    .candidate-name {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $black;
    }
  }
  .card-footer-text {
    color: $gray-light;

    .card-message {
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $danger;
    }
    .approved-title {
      color: $gray-dark;
    }
  }

  &::v-deep .v-list-item {
    padding: 0 10px;
  }
}
.reject-status {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  max-width: 85%;
}
.candidate-note {
  position: relative;
  .plus-icon {
    background: #e9e9e9;
    display: inline-flex;
    width: 20px;
    height: 20px;
    padding-top: 2px;
    justify-content: center;
    color: #384955;
    font-size: 16px;
    vertical-align: middle;
    font-weight: 700;
    line-height: 14px;
  }
  &:hover {
    i {
      box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.5);
      background: #e9e9e9;
    }
    .note-rejection {
      display: block;
    }
  }
  .note-rejection {
    border-radius: 8px;
    position: absolute;
    display: none;
    top: 50%;
    left: 100%;
    min-width: 280px;
    box-shadow: -1px 1px 12px rgba(0, 0, 0, 0.3) !important;
    z-index: 100;
    transform: translate(5px, -50%);
    padding-bottom: 10px;
    ::v-deep .v-card__title {
      font-weight: 500;
      color: #111827;
      font-size: 14px;
      text-align: center;
      display: none;
      padding: 12px;
      line-height: 1;
    }
    ::v-deep .v-label {
      font-size: 14px;
      color: #a1a5a6;
    }
    ::v-deep .v-card__text {
      font-size: 14px;
      color: #384955;
      max-height: 80px;
      overflow: auto;
    }
  }
}
.candidate-note-container {
  max-width: 85%;
}
.reject-title {
  color: $gray-dark;
  font-size: 12px;
  font-weight: 600;
}
.reject-text {
  color: $gray-dark;
  font-size: 13px;
  font-weight: 400;
  margin-left: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 135px;
  text-transform: capitalize;
}
.rejected-menu {
  &__title {
    width: 100%;
    text-align: center;
    color: #111827;
    letter-spacing: 0;
    font-weight: 500;
    font-size: 14px;
    padding: 4px 20px 0 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__text {
    color: $gray-dark;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 400;
    height: 120px;
    padding: 18px 10px 30px 20px;
    word-break: break-all;
    overflow-y: auto;
  }
}
.menu-list {
  padding-right: 6px;
  z-index: 100 !important;
  background-color: #ffff;
}
.v-tooltip__content {
  font-size: 12px !important;
  letter-spacing: 0.3px !important;
  color: #111827 !important;
  padding: 4px 7px 4px 7px !important;
  border-radius: 0 !important;
  box-shadow: -1px 1px 4px 0 rgba(0, 0, 0, 0.5);
  opacity: 1 !important;
  line-height: 15px;
}
</style>
